import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// import { useCookies } from 'react-cookie';

import * as S from './styles';
import bannerTop from '../../../assets/banner_home_01.png';
import bannerLeft from '../../../assets/banner_home_02.png';
import bannerRight from '../../../assets/banner_home_03.png';

import Header from '../../molecules/Header';
import NavBar from '../../molecules/NavBar';
import MainContent from '../../molecules/MainContent';
import ProductListHeading from '../../atoms/productlistheading';
import ProductListItems from '../../molecules/ProductListItems';
import Footer from '../../molecules/Footer';
import { useGetProducts } from '../../../database/repositories/ProductRepository';
import { firebaseAnalytics } from '../../../config/firebase';

function HomeView() {
  const [prodList = []] = useGetProducts({ limit: 4 });
  const [lastProdList = []] = useGetProducts({ limit: 4, sortBy: 'addedDate', sortOrder: 'desc' });
  const [recentProdList] = useState([]);

  // const [cookie] = useCookies(['productsBrowseHistory']);

  useEffect(() => {
    firebaseAnalytics.logEvent('homepage_visited');
    // getProducts(4, cookie.productsBrowseHistory.split(','))
    //  .then(recentProds => setRecentProdList(recentProds));
    // setCookie('productsBrowseHistory', updateCookieList(cookie.productsBrowseHistory, 'pareceQuesim!!'), { path: '/' });
  }, []);

  return (
    <S.Container>
      <Header />
      <NavBar />
      <MainContent>
        <Link to="/produto/cadastro">
          <img className="banner-home" src={bannerTop} alt="alt" />
        </Link>

        <S.UpperSection>
          <div>
            <h1>Destaques</h1>
            <span> Quer vender mais rápido? </span>
            <Link to="/produto/cadastro">Coloque seu anúncio aqui</Link>
          </div>
        </S.UpperSection>
        {prodList.length > 0 ? <ProductListItems items={prodList.slice(0, 4)} size="14pt" /> : null}

        <ProductListHeading
          title="Anúncios Recentes"
          side_link_to="/busca?sortOrder=desc&sortBy=addedDate"
          side_link_txt="Ver todos"
        />
        {lastProdList.length > 0 && <ProductListItems items={lastProdList} size="14pt" />}

        <S.MiddleBanners>
          <Link to="/produto/cadastro" style={{ width: 'calc(50% - 15px)' }}>
            <img src={bannerLeft} alt="alt" />
          </Link>
          <Link
            to="/busca?category=ferramentas"
            style={{ width: 'calc(50% - 15px)', display: 'flex', justifyContent: 'flex-end' }}>
            <img src={bannerRight} alt="alt" />
          </Link>
        </S.MiddleBanners>

        {recentProdList.length > 0 && (
          <>
            <ProductListHeading
              title="Últimos produtos vistos"
              side_link_to="/"
              side_link_txt="Ver histórico"
            />
            <ProductListItems items={recentProdList} size="14pt" />
          </>
        )}
        {/* cookie && <Txt>{cookie.productsBrowseHistory}</Txt> */}
      </MainContent>
      <Footer />
    </S.Container>
  );
}

export default HomeView;
